<template>
    <div class="mStep">
        <mt-steps direction="horizontal">
            <mt-step :status="status1">信息校验</mt-step>
            <mt-step :status="status2">绑定手机</mt-step>
            <mt-step :status="status3">设置密码</mt-step>
            <mt-step :status="status4">激活完成</mt-step>
        </mt-steps>
    </div>
</template>

<script>
    import { Step, Steps } from 'bh-mint-ui2';
    export default {
        name: "mStep",
        components: {Step,Steps},
        data() {
            return {
                status1: 'process',
                status2: 'process',
                status3: 'process',
                status4: 'process',
            }
        },
        props: {
            stepNum: {
                type: Number
            }
        },
        mounted() {
            if(this.stepNum == 0) {
                this.status1 = 'finish'
            } else if(this.stepNum == 1) {
                this.status1 = 'finish'
                this.status2 = 'finish'
            } else if(this.stepNum == 2) {
                this.status1 = 'finish'
                this.status2 = 'finish'
                this.status3 = 'finish'
            } else if(this.stepNum == 3) {
                this.status1 = 'finish'
                this.status2 = 'finish'
                this.status3 = 'finish'
                this.status4 = 'finish'
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// mStep.vue?d1c9453c